import { ProfileSettingsNew } from './ProfileSettingsNew'

export const ProfileSettings = () => {
    return <ProfileSettingsNew />
}
